












































































import Vue from 'vue'
import LetterEditor from '@/components/letters/EditorForCockpit.vue'
import LetterDisplay from '@/components/letters/DisplayForCockpit.vue'
import Supplemental from '@/components/layout/Collapse.vue'

import { CaseComments } from './WriteLetter.graphql'

export default Vue.extend({
  apollo: {
    comments: {
      query: CaseComments,
      variables() {
        return {
          caseId: this.caseId,
        }
      },
    },
  },
  data() {
    return {
      comments: { nodes: [] },
    }
  },
  components: {
    LetterDisplay,
    LetterEditor,
    Supplemental,
  },
  props: {
    number: {
      type: [String, Number],
      required: true,
      validator(value: string | number): boolean {
        return typeof value === 'number' || value === 'final' || !isNaN(parseInt(value))
      },
    },
    caseId: {
      type: String,
      required: true,
    },
    condition: {
      type: String,
      required: true,
      validator(value: string) {
        return ['ipt', 'cbt', 'cr', 'expo', 'counseling'].includes(value)
      },
    },
  },
  beforeCreate() {
    console.log('beforeCreate WriteLetter.vue')
  },
  beforeDestroy() {
    console.log('beforeDestroy WriteLetter.vue')
  },
  methods: {
    empty(copy: any): boolean {
      return (
        copy == undefined ||
        copy.body == undefined ||
        copy.body == null ||
        copy.body.trim().length == 0
      )
    },
    confirm(): boolean {
      return window.confirm(
        (this.$t('letters.confirmSend') as string) || 'Sure? No changes afterwards!'
      )
    },
    publish(copy: any) {
      copy.published_at = new Date()
      return copy
    },
  },
  computed: {
    isCounselingT2orT5(): boolean {
      if (this.condition === 'counseling' && (this.number == 2 || this.number == 5)) {
        return true
      }
      return false
    },
    scalingQuestionScore(): string {
      if (this.isCounselingT2orT5) {
        let timeOfMeasurement = this.number == 2 ? 'counseling_p1' : 'counseling_p4'
        let result = this.$store.getters['scaling/findBy']({
          case_id: this.caseId,
          time_of_measurement: timeOfMeasurement,
        })
        if (result == null || result == undefined) {
          return 'N/A'
        }
        return result.score.toString()
      }
      return 'N/A'
    },
  },
  mounted() {
    this.$store.dispatch({ type: 'scaling/fetch' })
  },
})
